import ApiService from "./api";

const Playlist = {
    getVideos(code, params) {
        return ApiService.get('playlist/'+code, {params: params});
    },
};

export default Playlist;